//types
import {RootState} from "../../../../types/store";
//import redux
import {connect} from "react-redux";

// actions
import {getSellerStatsRequest} from "../../../../redux/actions/dashboard/sellerStats.actions";

// types
import {DateRange} from "../../../../types/common";

// component
import LegacyComponent from "./Legacy.component";

interface ownProps {
  // filters
  rangeDate: DateRange;
  activeFilters: any;
  sendFilters: () => void;
  featuresAllowed: string[];
}

const mapStateToProps = function (state: RootState, ownProps: ownProps) {
  return {
    total: state.sellersStats.total,
    skip: state.sellersStats.skip,
    take: state.sellersStats.take,
    sellerStats: state.sellersStats.sellerStats,
    fetchingSellerStats: Boolean(
      state.sellersStats.fetchingSellerStats > 0
    ),
  };
};

const mapDispatchToProps = function (dispatch: any) {
  return {
    getSellerStatsRequest: (data: any, params: any) =>
      dispatch(getSellerStatsRequest(data, params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LegacyComponent);
